import { AutoComplete, AutoCompleteProps } from 'antd'
import React from 'react'
import styled from 'styled-components'

interface Props extends AutoCompleteProps {
  label?: string
  name?: string
  required?: boolean
  error?: string
}
export const AutoInput = ({ label, name, required, error, ...rest }: Props) => {
  return (
    <AutoInputStyled>
      {label && (
        <label
          htmlFor={name || label}
          className={`Input__label inline-flex items-center  mr-[1.25rem]  text-dark col-span-2  mb-2`}
        >
          {label}
          {required && (
            <span className="required text-[#B91C1C] font-bold"> *</span>
          )}
        </label>
      )}
      <AutoComplete
        filterOption
        allowClear
        status={error ? 'error' : ''}
        {...rest}
      />
      {error && (
        <div className={`grid grid-cols-7 w-full  text-danger`}>
          <div className={`Input__text-error mt-2 text-sm col-span-7`}>
            {error}
          </div>
        </div>
      )}
    </AutoInputStyled>
  )
}

const AutoInputStyled = styled.div`
  .ant-select {
    width: 100%;
  }
  .ant-select-selector {
    border-radius: 0.375rem !important;
    height: 40px !important;
  }
  .ant-select-selection-placeholder {
    line-height: 40px !important;
  }
  input {
    height: 100% !important;
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
    --tw-border-opacity: 0.4;
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
      var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
      calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
      var(--tw-shadow, 0 0 #0000);
    --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));
    --tw-ring-opacity: 0.2;
  }
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  }
  .ant-select-status-error.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer)
    .ant-select-selector {
    border-color: rgb(var(--color-danger) / 1) !important;
    box-shadow: none;
  }
`
